import { createAction } from 'redux-actions';

// Actions

export const DATA_FETCH_STARTED = 'accountData/DATA_FETCH_STARTED';

// Action creators

export const fetchAccountData = createAction(DATA_FETCH_STARTED);
